module.exports = __webpack_public_path__ + "img/bg_sixhat.da3cc8c7.jpg";